import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-download-widget',
  templateUrl: './download-widget.component.html',
  styleUrls: ['./download-widget.component.scss']
})
export class DownloadWidgetComponent implements OnInit {
  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {}

  install() {
    this.amplitudeService.logEvent('Panel:Widget:Install');
  }

  get getWidgetUrl() {
    return `https://chrome.google.com/webstore/detail/${environment.CHROME_STORE_WIDGET_ID}`;
  }
}
